/**
 * Online API Endpoints
 * These endpoints are used when IS_OFFLINE=false
 */
export const ONLINE_ENDPOINTS = {
  // Auth endpoints
  AUTH: {
    LOGIN: '/user/v1/login',
    LOGOUT: '/user/v1/logout',
    REGISTER: '/user/v1/register',
    REGISTRATION_DETAILS: '/user/v1/registration-details',
    SEND_OTP: '/user/v1/send-otp',
    RESEND_OTP: '/user/v1/resend-otp',
    OTP_LOGIN: '/user/v2/otp-login',
    // eslint-disable-next-line sonarjs/no-hardcoded-passwords
    RESET_PWD: '/user/v1/reset-password',
  },

  // User endpoints
  USER: {
    PROFILES: '/user/v1/profiles',
    SELECT_PROFILE: '/user/v1/profile/select',
    UPDATE_PROFILE: '/user/v1/profile', // Used with /{id} parameter
    SELECT_VARIANT: '/user/v1/select-variant', // Used with ?variant_id= query param
    UPCOMING_SESSION: '/user/v2/upcoming-session',
    REFERRAL_CODE: '/user/referrals/v1/get-referral-code',
    VIDEO_SEGMENTATION: '/user/v1/get-video-segmentation-data', // Used with /{session_id} parameter
    EXTRA_CLASSES: '/user/v1/extra_classes/upcoming',
    SESSIONS: '/user/v2/sessions',
    MODULES: '/user/v3/modules',
    ENROLL_EXISTING_PROFILE: '/user/v1/enroll_existing_profile',
    ENROLL_TO_COURSE: '/user/v1/enrol_to_course_from_student_dashboard',
    WAITLIST_JOIN: '/user/v1/waitlist/join',
    WAITLIST_STATUS: '/user/v1/waitlist/status',
  },

  // Assessments endpoints
  ASSESSMENTS: {
    MODULES_LIST: '/assessment/v1/users/reports/modules-list',
    MODULE_DETAIL: '/assessment/v1/users/reports/module-detail', // Used with /{moduleId}/{moduleStatus} parameters
    LEADERBOARD: '/assessment/v1/users/reports/get-leaderboard', // Used with /{grade} parameter
    MODULE_SUMMARY:
      '/assessment/v1/users/reports/get-module-assessment-summary',
    TOPIC_SUMMARY: '/assessment/v1/users/reports/get-topic-assessment-summary',
    QUIZ_ATTEMPT_SUMMARY:
      '/assessment/v1/users/reports/get-quiz-attempt-summary',
    RECOMMENDED_QUIZZES: '/assessment/v1/users/reports/get-recommended-quizzes',
    GENERATE_ROOM: '/assessment/v1/users/rooms/generate-room', // Used with /{roomId} parameter
  },

  // Batch/Streams endpoints
  BATCHES: {
    VARIANT_BATCH: '/streams/v1/variant/batch',
    AVAILABLE_BATCHES: '/batches/v1/onboarding/available-batches',
    ASSIGN_STUDENT: '/batches/v1/onboarding/assign-student',
    EDIT_ADDRESS: '/batches/v1/edit-address',
  },

  // Calendar/Communication endpoints
  COMMS: {
    STUDENT_HOLIDAYS: '/comms/student-holidays',
  },

  // Bhanzu Buddy (DoubtGPT) endpoints
  DOUBT_GPT: {
    ANSWER_QUESTIONS: '/doubtgpt/v1/answer_all_questions',
    FEEDBACK: '/doubtgpt/v1/feedback',
    INTERACTION_HISTORY: '/doubtgpt/v1/interaction_history',
  },

  // Payment endpoints
  PAYMENTS: {
    ENROLMENT_CREDITS_INFO: '/payments/v1/enrolment-credits-info',
  },
} as const;
